<template>
  <div class="present-movie-base">
    <base-attention v-if="!!attentionText" :text="attentionText" />
    <h1><span class="preface"><span>特典</span></span>動画占い</h1>
    <div class="expranation">お好きな動画占いを毎月1本無料でプレゼント。<span v-if="!isFirstTerm"><br>{{freeTermsWords}}（翌月に繰り越すことはできません）</span></div>
    <ul>
      <li v-for="(item, index) in movieLinksMod" :key="index" @click="onItemClick(item.url)">
        <span class="thumb-wrap"><img :src="item.thumbnail" /></span>
        <span class="info-wrap">
          <span class="title">{{item.title}}</span>
          <!-- <span class="description">{{item.description}}</span> -->
          <span class="item-foot">
            <link-icon :icon-type="linkIconType"/>
          </span>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import LinkIcon from "@/utvStore/components/partials/LinkIcon";
import BaseAttention from "@/utvStore/components/common/Attention"
import { SEC_ICON_TYPE } from '@/CONSTS/MENUS'

export default {
  name: "PresentMovie",
  components: {LinkIcon, BaseAttention},
  data() {
    return {
      lock: false
    }
  },
  props: {
    movieLinks: {
      type: Array,
      default(){
        return []
      }
    },
    presentInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    userProfile: {
      type: Object,
      default() {
        return {}
      }
    },
    // サブスクのお試し2週間無料が有効か
    isSubscTrial: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    isFirstTerm(){
      if(!!this.userProfile) {
        const subsc = this.userProfile.subscription
        return parseInt(subsc.active) === 1 && parseInt(subsc.status) === 0
      }
      return
    },
    attentionText() {
      if(!!this.userProfile){
        const subsc = this.userProfile.subscription
        const tgtDt = moment(subsc.next_payment_due)
        if(!!tgtDt && parseInt(subsc.active) === 1) {
          if(this.isSubscTrial && parseInt(subsc.status) === 0){
            return `2週間お試し期間中のためご利用できません。<br>${tgtDt.format('YYYY年M月D日')}以降、サブスクリプションを継続するとお申し込みいただけます。`
          } else if(parseInt(subsc.free_buy) === 0) {
            return `今月分はすでにご利用済みです。<br>${tgtDt.format('YYYY年M月D日')}以降お申し込みいただけます。`
          }
        }
      }
      return ''
    },
    linkIconType(){
      return SEC_ICON_TYPE.movie
    },
    movieLinksMod() {
      return this.movieLinks
    },
    freeTermsWords() {
      if(!!this.userProfile){
        const st = moment(parseInt(this.userProfile.subscription.current_peirod_from) * 1000)
        const ed = moment(parseInt(this.userProfile.subscription.current_peirod_to) * 1000)
        const stword = st.format('YYYY年M月D日')
        const edword = ed.format( st.year() === ed.year() ? 'M月D日' : 'YYYY年M月D日')
        return `${stword}〜${edword}分を1本申し込めます。`
      }
      return ''
    }
  },
  created() {
  },
  mounted() {
    this.lock = false
    dbg.info('[Digicon Info] page: %O, subsc: %O, userprop:%O', this.movieLinksMod, this.presentInfo, this.userProfile)
  },
  methods: {
    onItemClick(val){
      if(!this.lock && !!val) {
        this.lock = true
        location.href = val
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";
.present-movie-base {
  $baseMargin: 20px;
  $thumbSize: 140px;
  width: 100%;
  padding-bottom: 70px;

  /deep/ .attention {
    width: calc(100% - 20px - 20px;
    margin: 20px auto 0;
  }

  h1 {
    padding-top: 36px;
    padding-bottom: 36px;
    margin: 0;
    line-height: 1;
    width: 100%;
    text-align: center;
    font-weight: bold;
    font-size: 26px;
    color: $col_base_font;
    .preface {
      display: block;
      width: 100%;
      line-height: 1;
      font-size: 13px;
      margin-bottom: 15px;
      span {
        display: inline-block;
        padding: 6px 17px;
        border-radius: 20px;
        background: $col_def_gradient;
        color: $col_white;
      }
    }
  }
  .expranation {
    width: 100%;
    padding: 0 $baseMargin;
    color: $col_base_font;
    font-weight: normal;
    font-size: 13px;
    line-height: 21px;
    margin-bottom: 26px;
  }

  & > ul {
    padding: 0;
    margin: 0;
    list-style: none;
    width: 100%;
    & > li {
      width: 100%;
      position: relative;
      padding: $baseMargin $baseMargin $baseMargin ($baseMargin + $thumbSize + 17px);
      border-bottom: 1px solid $col_temp_gray3;
      cursor: pointer;
      &:first-child {
        border-top: 1px solid $col_temp_gray3;
      }
      .info-wrap {
        display: block;
        width: 100%;
        min-height: $thumbSize;
        padding-bottom: 20px;
        .title {
          display: block;
          width: 100%;
          font-weight: bold;
          font-size: 14px;
          line-height: 18px;
          color: $col_base_font;
          margin-bottom: 8px;
        }
        .description {
          font-weight: normal;
          font-size: 12px;
          line-height: 18px;
          color: $col_normal_font;
        }
        .item-foot {
          display: block;
          width: 100%;
          text-align: right;
          line-height: 1;
          position: absolute;
          bottom: $baseMargin;
          right: $baseMargin;
        }
      }
      .thumb-wrap {
        display: block;
        width: $thumbSize;
        height: $thumbSize;
        top: $baseMargin;
        left: $baseMargin;
        border-radius: 10px;
        overflow: hidden;
        position: absolute;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/lp/PresentMovie.vue